import { render, staticRenderFns } from "./availability-confirm.vue?vue&type=template&id=22250c66&scoped=true"
import script from "./availability-confirm.vue?vue&type=script&lang=js"
export * from "./availability-confirm.vue?vue&type=script&lang=js"
import style0 from "./availability-confirm.vue?vue&type=style&index=0&id=22250c66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22250c66",
  null
  
)

export default component.exports